import { SmsComponent } from './sms.component'

export const COMPONENTS = [SmsComponent]
